import { TableHeader } from "@mbs-npm/anpost-ui";
import { BenefitState, TableHeaderKey } from "../types";

export const multiTableHeaders: Array<TableHeader> = [
    { id: TableHeaderKey.INSURER_LIST, text: "List of Insurers", size: "lg" },
    { id: TableHeaderKey.BUILDINGS_COVERED, text: "Buildings Covered" },
    { id: TableHeaderKey.CONTENTS_COVERED, text: "Contents Covered" },
    { id: TableHeaderKey.HOME_EMERGENCY, text: "Home Emergency Response", moreInfo: "test" },
    { id: TableHeaderKey.FIRE_BRIGADE_CHARGES, text: "Fire Brigade Charges" },
    { id: TableHeaderKey.LEGAL_LIABILITY, text: "Public/Legal Liabiity" },
    { id: TableHeaderKey.ACTIONS, text: "Actions", size: "lg" }
];

export const singleTableHeaders: Array<TableHeader> = [
    { id: TableHeaderKey.BUILDINGS_COVERED, text: "Buildings Covered" },
    { id: TableHeaderKey.CONTENTS_COVERED, text: "Contents Covered" },
    { id: TableHeaderKey.HOME_EMERGENCY, text: "Home Emergency Response", moreInfo: "test" },
    { id: TableHeaderKey.FIRE_BRIGADE_CHARGES, text: "Fire Brigade Charges" },
    { id: TableHeaderKey.LEGAL_LIABILITY, text: "Public/Legal Liabiity" }
];

export function getAddonKey(key: TableHeaderKey, quote: BenefitState) {
    switch (key) {
        case TableHeaderKey.BUILDINGS_COVERED:
            return quote.hasBuildingsCovered;
        case TableHeaderKey.CONTENTS_COVERED:
            return quote.hasContentsCovered;
        case TableHeaderKey.HOME_EMERGENCY:
            return quote.hasHomeEmergency;
        case TableHeaderKey.FIRE_BRIGADE_CHARGES:
            return quote.hasFireBrigadeCharges;
        case TableHeaderKey.LEGAL_LIABILITY:
            return quote.hasLegalLiability;
    }
}
